var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupArrowRd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "popup-arrow",
    viewBox: "0 0 120 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#052334",
    points: "25 0 120 45 0 25 25 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupArrowRd);
export default __webpack_public_path__ + "static/media/popup-arrow-rd.a5497d3f5a5ebd745461d09561a12b8a.svg";
export { ForwardRef as ReactComponent };